import styled from 'styled-components';

const Checkbox = ({ isChecked }) => {
  return (
    <StyledWrapper isChecked={isChecked}>
      <label className="burger" htmlFor="burger">
        <span />
        <span />
        <span />
      </label>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .burger {
    position: relative;
    width: 33px;
    height: 26px;
    background: transparent;
    cursor: pointer;
    display: block;
  }

  .burger input {
    display: none;
  }

  .burger span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: white;
    border-radius: 10px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
  }

  .burger span:nth-of-type(1) {
    top: 0px;
    transform-origin: left center;
  }

  .burger span:nth-of-type(2) {
    top: 50%;
    transform: translateY(-50%);
    transform-origin: left center;
  }

  .burger span:nth-of-type(3) {
    top: 100%;
    transform-origin: left center;
    transform: translateY(-100%);
  }

  ${({ isChecked }) =>
    isChecked &&
    `
      .burger span:nth-of-type(1) {
        transform: rotate(45deg);
        top: 1px;
        left: 5px;
      }

      .burger span:nth-of-type(2) {
        width: 0%;
        opacity: 0;
      }

      .burger span:nth-of-type(3) {
        transform: rotate(-45deg);
        top: 25px;
        left: 5px;
      }
    `}
`;


export default Checkbox;
